<template>
    <div class="column is-6 is-offset-3 m-t-xxl">
        <!-- Error Messages -->
        <div class="card">
            <header class="card-header" style="background-color: #f5f5f5">
                <h2 class="card-header-title">Set Password</h2>
            </header>
            <div class="card-content">
                <div class="content">
                    <form @submit.prevent="onSubmit">
                        <b-field label="Email">
                            <b-input type="email" v-model="data.email_address"></b-input>
                        </b-field>
                        <b-field label="Password">
                            <b-input type="password" password-reveal v-model="data.password"></b-input>
                        </b-field>

                        <b-field label="Confirm Password">
                            <b-input
                                type="password"
                                password-reveal
                                v-model="data.password_confirmation"
                            ></b-input>
                        </b-field>

                        <nav class="level">
                            <div class="level-left m-t-sm"></div>

                            <div class="level-right m-t-sm">
                                <div class="level-item">
                                    <div class="field is-grouped">
                                        <p class="control">
                                            <button
                                                class="button is-dark"
                                                @click.prevent="submit"
                                            >Submit</button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { AuthService } from "@/services/auth.service.js";

export default {
    data() {
        return {
            data: {
                token: null,
                email_address: null,
                password: null,
                password_confirmation: null
            }
        };
    },
    mounted() {
        if (this.$route.query.token) {
            this.data.token = this.$route.query.token;
            this.data.email_address = this.$route.query.email;
        }
    },
    methods: {
        submit() {
            this.loading = true;

            AuthService.setPassword(this.data)
                .then(response => {
                    this.$store.dispatch("Auth/setToken", response.data.token);
                    this.$nextTick(() => {
                      this.$router.replace("/profile");
                    });
                })
                .catch(errors => {
                    this.$store.commit("SET_ERRORS", errors.response.data);
                    this.loading = false;
                });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/SetPassword/index.vue